import { cn } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';

import React from 'react';

import { isNil } from 'es-toolkit';
import { LucideIcon } from '../../LucideIcon';
import { formatReviewRating } from '@skin-seoul/utils';

const ProductCardInfoRating = () => {
  const { rating = 0, reviewCount = 0, theme = 'light' } = useProductCard();

  if (isNil(rating)) {
    return null;
  }

  if (rating > 0) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex flex-row items-center gap-1">
          <div className="flex gap-1">
            <LucideIcon name="Star" size={16} className="fill-neutral-700 text-neutral-700" />
          </div>
          <p
            className={cn('text-label-medium font-medium', theme === 'dark' ? 'text-neutral-200' : 'text-neutral-700')}
          >
            {formatReviewRating(rating)}
          </p>
        </div>

        <p className={cn('text-label-medium font-normal', theme === 'dark' ? 'text-neutral-200' : 'text-neutral-400')}>
          ({reviewCount.toFixed(0)})
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-[4px]">
      <p className={cn('text-paragraph-small', theme === 'dark' ? 'text-neutral-200' : 'text-neutral-400')}>&nbsp;</p>
    </div>
  );
};

export default ProductCardInfoRating;
